import React from 'react';
import { Linkedin, Twitter, Facebook, Instagram, Youtube, Globe } from 'lucide-react';

const ICONS = {
  linkedin: { Icon: Linkedin, color: '#0A66C2' },
  twitter: { Icon: Twitter, color: '#1DA1F2' },
  facebook: { Icon: Facebook, color: '#1877F2' },
  instagram: { Icon: Instagram, color: '#E4405F' },
  youtube: { Icon: Youtube, color: '#FF0000' },
  website: { Icon: Globe, color: '#1c1917' },
  tiktok: { Icon: Globe, color: '#000000' },
};

export default function EmailSocialBlock({ props, isSelected }) {
  const icons = props.icons || [];
  const size = parseInt(props.icon_size) || 24;

  return (
    <div style={{ padding: props.padding || '16px 24px', textAlign: props.alignment || 'center' }}>
      <div className="flex items-center justify-center gap-3 flex-wrap" style={{ justifyContent: props.alignment || 'center', gap: props.spacing || '12px' }}>
        {icons.map((item, i) => {
          const def = ICONS[item.platform] || ICONS.website;
          const { Icon, color } = def;
          const fill = props.icon_style === 'dark' ? '#1c1917' : props.icon_style === 'light' ? '#ffffff' : color;
          return (
            <a key={i} href={item.url || '#'} onClick={e => e.preventDefault()} title={item.platform}
              style={{ display: 'inline-flex', color: fill, textDecoration: 'none' }}>
              <Icon size={size} />
            </a>
          );
        })}
        {icons.length === 0 && isSelected && (
          <p className="text-xs text-stone-400">Add social links in the properties panel</p>
        )}
      </div>
    </div>
  );
}
